import React from 'react'
import PropTypes from 'prop-types'
import LazyLoad from 'vanilla-lazyload'
import ProductGridEmpty from './ProductGridEmpty'
import DetailedProductCard from '../ProductList/DetailedProductCard'
import { helpers } from '../../helpers'

/**
* Displays a list of detailed product cards in a grid.
*/
class ProductGrid extends React.Component {
  constructor(props) {
    super(props)
    this.uid = helpers.generateID('grid')
    this.selector = `#${this.uid}`

    this.trackProductImpression = this.trackProductImpression.bind(this)
    this.replaceImageWithFallback = this.replaceImageWithFallback.bind(this)
  }

  componentDidMount() {
    this.componentDidUpdate()
  }

  componentDidUpdate() {
    if (!this.props.products.length) {
      return
    }
    new LazyLoad({
      elements_selector: `#${this.uid} .is-lazy`,
      threshold: 200,
      data_src: 'original',
      data_srcset: 'original-set',
      callback_set: this.trackProductImpression,
      callback_error: this.replaceImageWithFallback,
    })
  }

  /**
  * `on_set` callback for image lazy load on product cards. Tracks a product
  * impression based on data from the given image.
  *
  * @param image {element} image element with tracking data attached.
  */
  trackProductImpression(image) {
    if (!image || !image.dataset.position) {
      return
    }

    const product = this.props.products[Number(image.dataset.position) - 1]

    if (!product) {
      return
    }

    let price = null


    let sku = null

    // Parse the price of the variant.
    if (product.variant && product.variant.price) {
      price = product.variant.price
    }

    // Parse the sku of the variant.
    if (product.variant && product.variant.sku) {
      sku = product.variant.sku
    } else {
      sku = product.sku || null
    }

    $.track('product impression', {
      id: sku,
      name: product.name,
      list: this.props.listName,
      brand: helpers.formatProducers(product.producers),
      category: product.variant ? product.variant.oracle_department_name : null,
      variant: product.variant ? product.variant.options_text_analytics : null,
      position: image.dataset.position,
      price,
    })
  }

  /**
  * `on_error` callback for image lazy load on product cards. Replaces the given
  * `image` dom element with a fallback text replacement with the `image`'s '
  * `fallbackText` data attribute value.
  *
  * @param image {element} failed image element that needs to be replaced.
  */
  replaceImageWithFallback(image) {
    debug.image('FAILURE', image)
    const fallbackText = document.createElement('span')

    if (!image || !('fallbackText' in image.dataset)) {
      return
    }
    fallbackText.className = 'product-fallback has-drop-shadow'
    fallbackText.appendChild(document.createTextNode(image.dataset.fallbackText))
    image.replaceWith(fallbackText)
  }

  render() {
    if (!this.props.products.length) {
      return <ProductGridEmpty />
    }

    return (
      <div className="product-grid" id={this.uid}>
        {this.props.products.map((product, idx) => (
          <div className="product-wrapper" key={product.id}>
            <DetailedProductCard
              product={product}
              isDisabled={this.props.isLoading}
              position={idx + 1}
              listName={this.props.listName}
            />
          </div>
          ))}
      </div>
    )
  }
}

ProductGrid.defaultProps = {
  isLoading: false,
  listName: 'Grid',
}

ProductGrid.propTypes = {
  // List of products to be displayed.
  products: PropTypes.array.isRequired,
  // If more products are being loaded and list should be disabled.
  isLoading: PropTypes.bool,
  // List name for Google Analytics.
  listName: PropTypes.string,
}

export default ProductGrid
